import { useEffect, useRef } from "react";
import { useQzTray } from "src/hooks/useQzTray";
import { getMyInfo } from "src/apis/userApi";
import { MinWidthWrapper } from "src/components/common/common";
import SpinnerOverlay from "src/components/common/SpinnerOverlay";
import Topbar from "src/components/common/topbar/Topbar";
import useUserStore from "src/store/useUserStore";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import { validateTokensForAppStart } from "src/utils/auth/tokenValidator";
import { redirectToSignin } from "src/utils/auth/sessionErrorHandler";
import useUiuxStore from "src/store/useUiuxStore";
import useMenuStore from "src/store/useMenuStore";
import { getMenuList } from "src/apis/menuApi";
import Sidebar from "src/components/common/sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import HomeContent from "./HomeContent";
import { CloseOutlined } from "@ant-design/icons";
import { TabUtils } from "src/utils/menu/tabUtils";
import { CodeSearchModal } from "src/components/common/modal/codeSearchModal/CodeSearchModal";
import { AuthactionbarLog } from "src/components/common/actionbar/AuthactionbarLog";
import ConfirmModal from "src/components/common/modal/ConfirmModal";
import { useDescText } from "src/hooks/useDescText";

const HomeContainer = () => {

	// QZ Tray 앱 시작 시 자동 연결
	useQzTray();
	
	const { userInfo, setUserInfo } = useUserStore();
	const { tabList, activeTab, setActiveTab, openTabContextMenu, codeSearchModalVisible, authactionbarLogModalVisible, confirmModalVisible } = useUiuxStore();
	const { menuList, setMenuList } = useMenuStore();
	const { loadingSpinner } = useLoadingSpinnerStore();
	const { handleExitClick } = TabUtils();
	const { renderDescText } = useDescText();

	const tabDivRef = useRef<HTMLDivElement>(null);

	const {
		handleLogoutClick,
		refreshMesInfo
	} = HomeContent({

	});

	return <div className={`w-full ${MinWidthWrapper} h-full flex flex-col`}>
		{/* <Topbar /> */}

		{loadingSpinner && <SpinnerOverlay text="처리 중입니다..." />}

		{/* 사이드바와 메인 컨텐츠를 가로로 배치하기 위한 컨테이너 */}
		<div className="flex flex-row flex-1 overflow-hidden">
			{/* 메뉴 데이터가 로드된 후에만 사이드바를 렌더링하여 에러를 방지합니다. */}
			{menuList.length > 0 && 
				<Sidebar
					data={menuList[0]} 
					handleLogoutClick={handleLogoutClick} refreshMesInfo={refreshMesInfo} />
			}
			
			{/* 메인 컨텐츠 영역 */}
			<main className="flex-1 flex flex-col overflow-y-auto">
				{/* 여기에 로그인 후 표시할 컨텐츠를 추가하세요 */}
					
					<div className="flex flex-col flex-1 h-full">
					<div 
							className="flex w-full shrink-0 flex-wrap content-start items-end gap-[4px] bg-[#EAF0F8] px-[14px] pt-[8px]"
							id='tabdiv'
							ref={tabDivRef}
							onContextMenu={openTabContextMenu}
							>
							{ tabList.map(tab => 
									<div key={tab.key} className={`relative flex flex-none cursor-pointer items-center gap-[12px] rounded-t-[12px] px-[16px] py-[11px] transition-colors
										${activeTab?.key === tab.key
											? 'bg-white text-[#1A2740] shadow-[inset_0_3px_0_#2F6FE0]'
											: 'bg-[#E6EDF8] text-[#5D6F8C]'}`}
										onClick={() => setActiveTab(tab)}>
										<p
											className="min-w-0 truncate whitespace-nowrap font-bold"
											style={{ fontSize: '14px' }}
										>
											{renderDescText(tab.key, tab.title)}
										</p>
										{!tab.fixed && (
											// tab - x버튼 닫기
											<CloseOutlined className="shrink-0 p-[2px] text-[12px] text-[#7D8799] opacity-60 hover:opacity-100" onClick={(e) => { e.stopPropagation(); handleExitClick(tab.key); }} />
										)}
									</div>
								)
							}
						</div>
						<div className="flex flex-1 overflow-x-auto ">
							{activeTab?.component && <activeTab.component />}
						</div>
					</div>
			</main>
		</div>
		{codeSearchModalVisible && <CodeSearchModal />}
		{authactionbarLogModalVisible && <AuthactionbarLog />}
		{confirmModalVisible && <ConfirmModal />}
	</div>
}

export default HomeContainer;
